export const SET_COMPANY = 'SET_COMPANY';
